function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React from "react";
import { Dialog, Classes } from "@blueprintjs/core";
import { Rnd } from "react-rnd";
import "./style.css";
var defaultDialogWidth = 400;
var defaultDialogHeight = 100;

var ResizableDraggableDialog = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(ResizableDraggableDialog, _React$Component);

  function ResizableDraggableDialog() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;

    _defineProperty(_assertThisInitialized(_this), "state", {
      x: 0,
      y: 0,
      width: defaultDialogWidth,
      height: defaultDialogHeight
    });

    _defineProperty(_assertThisInitialized(_this), "setDefaults", function (_temp) {
      var _ref = _temp === void 0 ? {} : _temp,
          doNotSetXOrWidth = _ref.doNotSetXOrWidth;

      var _this$props = _this.props,
          width = _this$props.width,
          height = _this$props.height;

      var _this$getWindowWidthA = _this.getWindowWidthAndHeight(),
          windowWidth = _this$getWindowWidthA.windowWidth,
          windowHeight = _this$getWindowWidthA.windowHeight;

      var heightToUse;

      if (height) {
        heightToUse = height;
      } else {
        heightToUse = (document.querySelector(".bp3-dialog-body") || {}).scrollHeight;

        if (heightToUse) {
          heightToUse = heightToUse + 60;
        } else {
          heightToUse = defaultDialogHeight;
        }
      }

      var widthToUse;

      if (width) {
        widthToUse = width;
      } else {
        widthToUse = defaultDialogWidth;
      }

      _this.setState(_extends({}, doNotSetXOrWidth ? {} : {
        x: Math.round(Math.max((windowWidth - widthToUse) / 2, 0)),
        width: Math.min(widthToUse, windowWidth)
      }, {
        y: Math.round(Math.max((windowHeight - heightToUse) / 2, 0)),
        height: Math.min(Math.max(defaultDialogHeight, heightToUse), windowHeight)
      }));
    });

    _defineProperty(_assertThisInitialized(_this), "onWindowResize", function () {
      _this.setDefaults();
    });

    _defineProperty(_assertThisInitialized(_this), "getWindowWidthAndHeight", function () {
      var w = window,
          d = document,
          e = d.documentElement,
          g = d.getElementsByTagName("body")[0],
          windowWidth = w.innerWidth || e.clientWidth || g.clientWidth,
          windowHeight = w.innerHeight || e.clientHeight || g.clientHeight;
      return {
        windowWidth: windowWidth,
        windowHeight: windowHeight - 20 //add a small correction here

      };
    });

    return _this;
  }

  var _proto = ResizableDraggableDialog.prototype;

  _proto.componentDidMount = function componentDidMount() {
    var _this2 = this;

    window.addEventListener("resize", this.onWindowResize);
    this.setDefaults();
    setTimeout(function () {
      _this2.setDefaults();

      try {
        var el = _this2.containerEl.querySelector(".bp3-dialog-body");

        _this2.resizeObs = new ResizeObserver(function () {
          _this2.setDefaults({
            doNotSetXOrWidth: true
          });
        });

        _this2.resizeObs.observe(el);
      } catch (e) {
        console.warn("1214124599 Error setting up resize observer on dialog :", e);
      }
    }, 0);
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    this.resizeObs && this.resizeObs.disconnect();
    window.removeEventListener("resize", this.onWindowResize);
  };

  _proto.render = function render() {
    var _this3 = this;

    var _this$props2 = this.props,
        width = _this$props2.width,
        height = _this$props2.height,
        RndProps = _this$props2.RndProps,
        rest = _objectWithoutPropertiesLoose(_this$props2, ["width", "height", "RndProps"]);

    var _this$getWindowWidthA2 = this.getWindowWidthAndHeight(),
        windowWidth = _this$getWindowWidthA2.windowWidth,
        windowHeight = _this$getWindowWidthA2.windowHeight;

    return /*#__PURE__*/React.createElement("div", {
      ref: function ref(el) {
        if (el) _this3.containerEl = el;
      },
      className: "tg-bp3-dialog-resizable-draggable",
      style: {
        top: 0,
        left: 0,
        position: "fixed"
      }
    }, /*#__PURE__*/React.createElement(Rnd, _extends({
      cancel: ".bp3-dialog-close-button",
      enableResizing: {
        bottomLeft: true,
        bottomRight: true,
        topLeft: true,
        topRight: true
      },
      maxHeight: windowHeight,
      maxWidth: windowWidth,
      bounds: "window",
      size: {
        width: this.state.width,
        height: this.state.height
      },
      position: {
        x: this.state.x,
        y: this.state.y
      },
      onDragStop: function onDragStop(e, d) {
        _this3.setState({
          x: d.x,
          y: d.y
        });
      },
      onResizeStop: function onResizeStop(e, direction, ref, delta, position) {
        _this3.setState(_extends({
          width: ref.style.width,
          height: ref.style.height
        }, position));
      },
      dragHandleClassName: Classes.DIALOG_HEADER
    }, RndProps), /*#__PURE__*/React.createElement(Dialog, _extends({
      enforceFocus: false,
      hasBackdrop: false,
      usePortal: false,
      canEscapeKeyClose: true
    }, rest))));
  };

  return ResizableDraggableDialog;
}(React.Component);

export { ResizableDraggableDialog as default };